var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "" } },
            [
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div1" }, [_vm._v("商品管理")]),
              ]),
              _c(
                "el-breadcrumb-item",
                { attrs: { to: { path: "/addGoodsWareHouse" } } },
                [_c("div", { staticClass: "div2" }, [_vm._v("仓库库位")])]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("p", { staticClass: "header" }, [_vm._v("添加库位")]),
          _c(
            "el-form",
            {
              staticClass: "demo-form-inline",
              attrs: { inline: true, model: _vm.formInline1 },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "仓库库位" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入库位名称" },
                    model: {
                      value: _vm.formInline1.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.formInline1, "name", $$v)
                      },
                      expression: "formInline1.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.listAxios(1)
                        },
                      },
                    },
                    [_vm._v("搜索")]
                  ),
                  _vm.parArray.indexOf("locationAddCode") != -1
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              _vm.dialoVisible = true
                              _vm.formInline = {}
                            },
                          },
                        },
                        [_vm._v("新增库位")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "manage" }, [
        _c("p", { staticClass: "header" }, [_vm._v("管理分类")]),
        _c(
          "div",
          { staticClass: "table" },
          [
            _c(
              "el-table",
              { attrs: { data: _vm.tableData.list } },
              [
                _c("el-table-column", {
                  attrs: { label: "序号", type: "index", width: "50px;" },
                }),
                _c("el-table-column", {
                  attrs: { scope: "scope", label: "仓库名称", width: "200" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [_c("span", [_vm._v(_vm._s(scope.row.warName))])]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { scope: "scope", label: "库位名称", width: "200" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.edit
                            ? _c("el-input", {
                                model: {
                                  value: scope.row.name,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "name", $$v)
                                  },
                                  expression: "scope.row.name",
                                },
                              })
                            : _c("span", [_vm._v(_vm._s(scope.row.name))]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "更新时间" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$moment(scope.row.createdTime))),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "操作" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", { staticClass: "optain" }, [
                            !scope.row.edit &&
                            _vm.parArray.indexOf("locationEditCode") != -1
                              ? _c(
                                  "p",
                                  {
                                    on: {
                                      click: function ($event) {
                                        scope.row.edit = !scope.row.edit
                                      },
                                    },
                                  },
                                  [_c("span", [_vm._v("编辑")])]
                                )
                              : _vm._e(),
                            scope.row.edit &&
                            _vm.parArray.indexOf("locationEditCode") != -1
                              ? _c(
                                  "p",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.fixHouser(scope.row)
                                      },
                                    },
                                  },
                                  [_c("span", [_vm._v("保存")])]
                                )
                              : _vm._e(),
                            scope.row.edit &&
                            _vm.parArray.indexOf("locationEditCode") != -1
                              ? _c(
                                  "p",
                                  {
                                    on: {
                                      click: function ($event) {
                                        ;(scope.row.edit = !scope.row.edit),
                                          (scope.row.name = scope.row.name1),
                                          (scope.row.warName =
                                            scope.row.warName1)
                                      },
                                    },
                                  },
                                  [_c("span", [_vm._v("取消")])]
                                )
                              : _vm._e(),
                            _vm.parArray.indexOf("locationDelect") != -1
                              ? _c(
                                  "p",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.delect(
                                          scope.row,
                                          scope.$index
                                        )
                                      },
                                    },
                                  },
                                  [_c("span", [_vm._v("删除")])]
                                )
                              : _vm._e(),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialoVisible,
            "append-to-body": true,
            title: "新增库位",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialoVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "form" },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    "label-position": "right",
                    "label-width": "80px",
                    model: _vm.formInline,
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "仓库名称" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            size: "small",
                            clearable: "",
                            placeholder: "请选择商品仓库",
                          },
                          model: {
                            value: _vm.formInline.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.formInline, "name", $$v)
                            },
                            expression: "formInline.name",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: this.content.name,
                              value: this.content.name,
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: this.content.damagedName,
                              value: this.content.damagedName,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "库位名称" } },
                    [
                      _c("el-input", {
                        attrs: { maxlength: "30" },
                        model: {
                          value: _vm.formInline.location,
                          callback: function ($$v) {
                            _vm.$set(_vm.formInline, "location", $$v)
                          },
                          expression: "formInline.location",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: {
                        click: function ($event) {
                          _vm.dialoVisible = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.onSubmit()
                        },
                      },
                    },
                    [_vm._v("确认")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }